import style from './HorizontalContainer.module.css';

interface Props {
  children: React.ReactNode;
}

export default function HorizontalContainer({ children }: Props) {
  return <div className={style.horizontalContainer}>{children}</div>;
}
